import axios from 'axios';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';

import { Config } from '../common/config'; // 서버 주소 등 공통 설정
import LeftMenu from '../components/leftMenu';
import { getErrorMessage } from '../components/utils';
import translations from '../data/translation';
import useStoreNo from '../hooks/useStoreNo';

export default function MarketingManagementPage() {
  const language = useSelector(state => state.language.language);
  const t = translations[language];
  const storeNo = useStoreNo();
  const [modalInfo, setModalInfo] = useState({
    mainMsg: '',
    isCancel: false,
    isConfirm: false,
  });
  const [isModalOpen, setModalOpen] = useState(false);

  // 개별 푸시알림 입력 상태
  const [userId, setUserId] = useState('');
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');

  // 전체 푸시알림 (기존)
  const pushAlarm = async () => {
    try {
      await axios.get(Config.API_SERVER + 'fcm/push', {
        withCredentials: true,
      });
      setModalInfo({
        ...modalInfo,
        mainMsg: '푸시알림이 정상적으로 전송되었습니다.',
        isCancel: false,
        isConfirm: true,
      });
      setModalOpen(true);
    } catch (error) {
      setModalInfo({
        ...modalInfo,
        mainMsg:
          getErrorMessage(error?.response) || '푸시알림 전송에 실패했습니다.',
        isCancel: false,
        isConfirm: true,
      });
      setModalOpen(true);
      console.error('Error pushAlarm:', error);
    }
  };

  // 개별 푸시알림
  const pushUserAlarm = async e => {
    e.preventDefault();
    if (!userId || !title || !message) {
      setModalInfo({
        ...modalInfo,
        mainMsg: 'userId, 제목, 내용을 모두 입력하세요.',
        isCancel: false,
        isConfirm: true,
      });
      setModalOpen(true);
      return;
    }
    try {
      await axios.post('https://api-admin-dev.naegift.com/fcm/push/user', {
        userId,
        title,
        message,
      });
      setModalInfo({
        ...modalInfo,
        mainMsg: '개별 푸시알림이 정상적으로 전송되었습니다.',
        isCancel: false,
        isConfirm: true,
      });
      setModalOpen(true);
      setUserId('');
      setTitle('');
      setMessage('');
    } catch (error) {
      setModalInfo({
        ...modalInfo,
        mainMsg:
          getErrorMessage(error?.response) ||
          '개별 푸시알림 전송에 실패했습니다.',
        isCancel: false,
        isConfirm: true,
      });
      setModalOpen(true);
      console.error('Error pushUserAlarm:', error);
    }
  };

  return (
    <>
      <section className="location_box location_box_mypage">
        <ul className="location_001">
          <li>
            <NavLink to={storeNo ? `/${storeNo}/gift-list` : '/gift-list'}>
              {t.home}
            </NavLink>
          </li>
          <li>
            <NavLink to={storeNo ? `/${storeNo}/qna-list` : '/qna-list'}>
              {t.serviceInquiry}
            </NavLink>
          </li>
        </ul>
      </section>
      <main>
        <section className="contants_box contants_box_mypage">
          <LeftMenu pageName="marketing" />
          <section className="rightcontant_box">
            <h2 className="tit_01">마케팅 관리</h2>

            <section className="contants_box_03">
              <h2 className="sectionTitle">🔔 푸시 알림 발송</h2>
              <p className="sectionDescription">
                이벤트, 프로모션, 공지사항 등의 푸시 알림을 사용자에게 전송할 수
                있습니다.
              </p>
              <button
                type="button"
                onClick={pushAlarm}
                className="button_05 button_black"
              >
                {t.pushalarm}
              </button>
            </section>

            <section className="contants_box_03" style={{ marginTop: 40 }}>
              <h2 className="sectionTitle">👤 개별 푸시 알림</h2>
              <form onSubmit={pushUserAlarm}>
                <div style={{ marginBottom: 10 }}>
                  <label style={{ marginRight: 10 }}>userId</label>
                  <input
                    type="text"
                    value={userId}
                    onChange={e => setUserId(e.target.value)}
                    placeholder="f3cd2948-bbab-4dbf-9594-85d7c9f336f3"
                    style={{ width: 320 }}
                  />
                </div>
                <div style={{ marginBottom: 10 }}>
                  <label style={{ marginRight: 10 }}>제목</label>
                  <input
                    type="text"
                    value={title}
                    onChange={e => setTitle(e.target.value)}
                    placeholder="알림 제목"
                    style={{ width: 320 }}
                  />
                </div>
                <div style={{ marginBottom: 10 }}>
                  <label style={{ marginRight: 10 }}>내용</label>
                  <input
                    type="text"
                    value={message}
                    onChange={e => setMessage(e.target.value)}
                    placeholder="알림 내용"
                    style={{ width: 320 }}
                  />
                </div>
                <button type="submit" className="button_05 button_black">
                  개별 푸시알림 전송
                </button>
              </form>
            </section>

            {/* 모달 출력 예시 (모달 컴포넌트 따로 구현되어 있어야 함) */}
            {isModalOpen && (
              <div className="modal">
                <div className="modalContent">
                  <p>{modalInfo.mainMsg}</p>
                  <button
                    onClick={() => setModalOpen(false)}
                    className="modalButton"
                  >
                    확인
                  </button>
                </div>
              </div>
            )}
          </section>
        </section>
      </main>
    </>
  );
}
